'use strict';

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _stringsAndConstants = require('./strings-and-constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

require('./cancel-subscription-form.scss');


var CancelSubscriptionForm = _baseForm2['default'].createFormClass({

    displayName: 'CancelSubscriptionForm',

    propTypes: {
        'isHf': _react2['default'].PropTypes.bool, // maybe get dynamically from helpers
        'isTeamAdmin': _react2['default'].PropTypes.bool,
        'hasHipaa': _react2['default'].PropTypes.bool,
        'hasBothApiAndUiPlans': _react2['default'].PropTypes.bool,
        'redirectUrl': _react2['default'].PropTypes.string,
        'showCustomerCancelOffer': _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            supportMessage: '',
            justApi: false,
            justUi: false,
            // Individual fields to hide (not sections, such as competitor or support contact)
            showFields: {
                'cancel_reason_features-detail': false
            },
            // Competitor info
            cancelForCompetitor: false,
            competitorName: '',
            competitorAutocompleteMatches: [],
            shouldShowCompetitorAutocomplete: false,
            shouldShowCompetitorReasons: false,
            // Validation
            hasAttemptedSubmit: false,
            supportShouldContactFilled: false,
            atLeastOneReasonChecked: false,
            errors: {},
            // Null means don't set it to be selected to begin with
            supportShouldContact: null,
            canWeFollowUp: null
        };
    },


    /**
    * Handlers
    */

    onCompetitorAutocompleteItemClick: function onCompetitorAutocompleteItemClick(e) {
        var text = e.target.innerHTML;
        this.setState({
            competitorName: text,
            shouldShowCompetitorAutocomplete: false
        });
    },
    onSupportMessageChange: function onSupportMessageChange(e) {
        var message = e.target.value;

        this.setState({
            supportMessage: message
        });
    },
    onPlanSwitchChange: function onPlanSwitchChange(e) {

        var newState = {};

        if (e.target.name === 'cancel[just_ui]') {
            newState.justUi = e.target.checked;
        } else if (e.target.name === 'cancel[just_api]') {
            newState.justApi = e.target.checked;
        }

        this.setState(newState);
    },
    onReasonListChange: function onReasonListChange(e) {

        var newState = {};
        newState.atLeastOneReasonChecked = document.querySelectorAll('input[type="checkbox"]:checked').length > 0;

        if (e.target.name === 'cancel[cancel_reason_features]') {
            newState.showFields = {};
            newState.showFields['cancel_reason_features-detail'] = e.target.checked;
        }

        if (e.target.name === 'cancel[cancel_reason_competitor]') {
            newState.cancelForCompetitor = e.target.checked;
        }

        this.setState(newState);
    },
    onCompetitorNameChange: function onCompetitorNameChange(e) {
        var name = e.target.value;
        var list = [];

        if (name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD) {
            // Cheap implentation of autocomplete, but enough for this case
            var re = new RegExp(name, 'i');
            list = _stringsAndConstants.cancelConstants.competitorList.filter(function (competitor) {
                return competitor.match(re);
            });
        }

        this.setState({
            competitorName: name,
            competitorAutocompleteMatches: list,
            shouldShowCompetitorAutocomplete: name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD,
            shouldShowCompetitorReasons: name.length > _stringsAndConstants.cancelConstants.AUTOCOMPLETE_MIN_THRESHOLD
        });
    },
    onSupportShouldContactChange: function onSupportShouldContactChange(e) {
        var shouldContact = e.target.value === 'yes' ? true : false;
        this.setState({
            supportShouldContactFilled: true,
            supportShouldContact: shouldContact
        });
    },
    onCanWeFollowUpChange: function onCanWeFollowUpChange(e) {
        var canWeFollowUp = e.target.value === 'yes' ? true : false;
        this.setState({
            canWeFollowUp: canWeFollowUp
        });
    },
    onSubmit: function onSubmit(e) {

        // Validation
        this.setState({ hasAttemptedSubmit: true });
        var valid = this.validateForm() && this.validateSupportMessage() && this.validatePlanSwitch();

        e.preventDefault();
        if (valid) {
            $('#cancel_form').submit();
        }
    },


    /**
    * Validation
    */

    validateForm: function validateForm() {
        if (this.state.supportShouldContactFilled && this.state.atLeastOneReasonChecked) {
            return true;
        }
        return false;
    },
    validateSupportMessage: function validateSupportMessage() {

        // Don't need to fill in if no contact needed
        if (!this.state.supportShouldContact) {
            return true;
        }

        if (this.state.supportMessage.length >= _stringsAndConstants.cancelConstants.SUPPORT_MESSAGE_MIN_THRESHOLD) {
            return true;
        }

        return false;
    },
    validatePlanSwitch: function validatePlanSwitch() {

        if (!this.props.hasBothApiAndUiPlans) {
            return true;
        }

        if (this.state.justUi || this.state.justApi) {
            return true;
        }

        return false;
    },


    /**
    * Sub render methods
    */

    renderCancelWarning: function renderCancelWarning() {
        var legalText = this.props.isHf ? _stringsAndConstants.cancelStrings.legalText.HF : _stringsAndConstants.cancelStrings.legalText.HS;
        return _react2['default'].createElement(
            'span',
            null,
            legalText.head,
            _react2['default'].createElement(
                'a',
                { href: '/info/tos' },
                ' ',
                legalText.link,
                ' '
            ),
            legalText.tail
        );
    },
    renderPlanSwitch: function renderPlanSwitch() {

        var self = this;

        var error = this.state.hasAttemptedSubmit && !this.state.justUi && !this.state.justApi;

        var justApiToggle = this.renderField('just_api', {
            'data-format': 'inputcheckbox',
            'value': this.state.justApi,
            'onChange': self.onPlanSwitchChange
        });

        var justUiToggle = this.renderField('just_ui', {
            'data-format': 'inputcheckbox',
            'value': this.state.justUi,
            'onChange': self.onPlanSwitchChange
        });

        return _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--plan-switch-container' },
            _react2['default'].createElement(
                'div',
                { className: 'm-settings--cancel--api-option' },
                justApiToggle,
                _react2['default'].createElement(
                    'label',
                    { htmlFor: 'cancel_just_api' },
                    'Cancel API plan \xA0'
                ),
                justUiToggle,
                _react2['default'].createElement(
                    'label',
                    { htmlFor: 'cancel_just_ui' },
                    'Cancel web plan'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-settings--cancel--error' },
                error ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0
            )
        );
    },
    renderYesNoToggle: function renderYesNoToggle(fieldName, sectionLabelName, onChange) {

        var sectionLabel = _react2['default'].createElement(
            'h2',
            null,
            sectionLabelName
        );

        var yesSelected = false,
            noSelected = false;
        if (fieldName === 'support_should_contact' && this.state.supportShouldContact !== null) {
            yesSelected = this.state.supportShouldContact;
            noSelected = !yesSelected;
        } else if (fieldName === 'can_provide_more_info' && this.state.canWeFollowUp !== null) {
            yesSelected = this.state.canWeFollowUp;
            noSelected = !yesSelected;
        }

        var yes = this.renderField(fieldName, {
            'tabIndex': 2,
            'data-format': 'selectradio',
            'onChange': onChange,
            'name': fieldName,
            'value': 'yes',
            'checked': yesSelected
        });
        var yesLabel = _react2['default'].createElement(
            'label',
            { htmlFor: fieldName },
            'Yes'
        );
        var no = this.renderField(fieldName, {
            'tabIndex': 2,
            'data-format': 'selectradio',
            'onChange': onChange,
            'name': fieldName,
            'value': 'no',
            'checked': noSelected
        });
        var noLabel = _react2['default'].createElement(
            'label',
            { htmlFor: fieldName },
            'No'
        );
        return _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--toggle-container' },
            sectionLabel,
            yes,
            yesLabel,
            no,
            noLabel
        );
    },
    renderReasonForCancelList: function renderReasonForCancelList() {
        return this.renderReasonsList('cancel_reason', _stringsAndConstants.cancelStrings.cancelReasons);
    },
    renderCompetitorReasonList: function renderCompetitorReasonList() {
        return this.renderReasonsList('competitor_reason', _stringsAndConstants.cancelStrings.competitorReasons);
    },
    renderReasonsList: function renderReasonsList(namePrefix, namesToReasonLabelMap) {
        var self = this;
        var regex = new RegExp(namePrefix);
        var reasons = this.props.fields.filter(function (field) {
            return field.name && field.name.match(regex);
        });

        var list = [];
        reasons.forEach(function (reason, index) {
            var component;
            switch (reason.type) {

                case 'inputcheckbox':
                    var field = self.renderField(reason.name, {
                        'tabIndex': 2,
                        'data-format': 'inputcheckbox',
                        'onChange': self.onReasonListChange,
                        'name': reason.name,
                        'key': reason.name
                    });
                    var label = _react2['default'].createElement(
                        'label',
                        {
                            htmlFor: reason.name },
                        namesToReasonLabelMap[reason.name]
                    );
                    component = _react2['default'].createElement(
                        'li',
                        { key: index, className: 'm-settings--cancel--reason-list--item' },
                        field,
                        label
                    );
                    break;

                case 'textarea':
                    if (self.state.showFields.hasOwnProperty(reason.name) && !self.state.showFields[reason.name]) {
                        component = void 0;
                    } else {
                        var field = self.renderField(reason.name, {
                            'tabIndex': 2,
                            'data-format': 'textarea',
                            'onChange': self.onReasonListChange,
                            'name': reason.name,
                            'key': reason.name,
                            'placeholder': _stringsAndConstants.cancelStrings.placeholders[reason.name]
                        });
                        component = _react2['default'].createElement(
                            'li',
                            { key: index },
                            field
                        );
                    }
                    break;

                default:
                    component = _react2['default'].createElement('li', { key: index });

            }
            if (component) {
                list.push(component);
            }
        });

        return _react2['default'].createElement(
            'ul',
            { className: 'm-settings--cancel--reason-list' },
            list
        );
    },
    renderTeamAdminWarning: function renderTeamAdminWarning() {
        return _react2['default'].createElement(
            'span',
            null,
            _react2['default'].createElement('br', null),
            _stringsAndConstants.cancelStrings.teamAdminWarning
        );
    },
    renderCompetitorAutocomplete: function renderCompetitorAutocomplete() {
        var _this = this;

        var matches = this.state.competitorAutocompleteMatches;
        if (this.state.shouldShowCompetitorAutocomplete) {
            return _react2['default'].createElement(
                'div',
                { className: 'm-settings--cancel--competitor-autocomplete' },
                _react2['default'].createElement(
                    'ul',
                    null,
                    matches.map(function (match) {
                        return _react2['default'].createElement(
                            'li',
                            { className: 'm-settings--cancel--competitor-autocomplete--item',
                                onClick: _this.onCompetitorAutocompleteItemClick },
                            match
                        );
                    })
                )
            );
        }
    },


    /**
    * Main render
    */

    render: function render() {

        var tabOffset = parseInt(this.props.tabOffset || 0, 10);
        var siteCode = this.props.isHf ? _hfReactHelper2['default'].HfSites.SITE_CODE_HF : _hfReactHelper2['default'].HfSites.SITE_CODE_HS;

        var reminderList = this.props.isHf ? void 0 : _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--reminder' },
            _react2['default'].createElement(
                'div',
                { className: 'm-settings--cancel--reminder--title' },
                'FREE ACCOUNTS DON\'T INCLUDE'
            ),
            _react2['default'].createElement(
                'ul',
                null,
                _react2['default'].createElement(
                    'li',
                    null,
                    'Unlimited documents'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Templates'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'In-person signing'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Two-factor Authentication'
                ),
                this.props.hasHipaa ? _react2['default'].createElement(
                    'li',
                    null,
                    'HIPAA compliance'
                ) : void 0
            )
        );

        var supportShouldContactToggle = this.renderYesNoToggle('support_should_contact', 'Do you need a Support Representative to follow up with you?', this.onSupportShouldContactChange);

        var supportMessageTextArea = this.renderField('support_message', {
            'tabIndex': tabOffset + 1,
            'placeholder': 'Please briefly describe the issue',
            'data-format': 'textarea',
            'onChange': this.onSupportMessageChange
        });

        var supportError = !this.state.supportShouldContactFilled && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0;
        var supportMessageError = !this.validateSupportMessage() && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.messageTooShort : void 0;

        var customerSupportInfo = _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--support' },
            supportShouldContactToggle,
            this.state.supportShouldContact ? supportMessageTextArea : void 0,
            _react2['default'].createElement(
                'div',
                { className: 'm-settings--cancel--error' },
                supportError,
                supportMessageError
            )
        );

        var canWeFollowUpToggle = this.renderYesNoToggle('can_provide_more_info', 'Would you be willing to provide more information about your experience if needed?', this.onCanWeFollowUpChange);

        var competitorNameField = this.renderField('competitor_name', {
            'tabIndex': tabOffset + 1,
            'placeholder': 'Please enter the name of the company you\'ve chosen',
            'data-format': 'input',
            'onChange': this.onCompetitorNameChange,
            'value': this.state.competitorName
        });

        var competitorAutocomplete = this.renderCompetitorAutocomplete();

        var competitorReasons = this.state.shouldShowCompetitorReasons ? _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--reason-container' },
            _react2['default'].createElement(
                'h2',
                null,
                'Please indicate your reasons for choosing them :'
            ),
            _react2['default'].createElement(
                'h4',
                null,
                'Please select all that apply.'
            ),
            this.renderCompetitorReasonList()
        ) : void 0;

        var competitorInfo = this.state.cancelForCompetitor ? _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--competitor-info' },
            competitorNameField,
            competitorAutocomplete,
            competitorReasons
        ) : void 0;

        var reasonsError = !this.state.atLeastOneReasonChecked && this.state.hasAttemptedSubmit ? _stringsAndConstants.cancelStrings.errors.noSelection : void 0;

        var cancellationAndCompetitorReasons = _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--reason-container' },
            _react2['default'].createElement(
                'h2',
                null,
                'Why are you canceling your service with us?'
            ),
            _react2['default'].createElement(
                'h4',
                null,
                'Please select all that apply.'
            ),
            this.renderReasonForCancelList(),
            competitorInfo,
            _react2['default'].createElement(
                'div',
                { className: 'm-settings--cancel--error' },
                reasonsError
            )
        );

        var customerComments = _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
                'h2',
                null,
                'Anything else you\'d like to tell us?'
            ),
            this.renderField('customer_comments', {
                'tabIndex': tabOffset + 1,
                'placeholder': 'Thank you so much for taking the time to provide us with feedback.',
                'data-format': 'textarea'
            })
        );

        var cancelLegalWarning = _react2['default'].createElement(
            'p',
            { className: 'm-settings--cancel--warning' },
            this.renderCancelWarning(),
            this.props.isTeamAdmin ? this.renderTeamAdminWarning() : void 0
        );

        var cancelButtonText = this.props.showCustomerCancelOffer ? 'Continue' : 'Cancel my subscription';
        var ctaButtons = _react2['default'].createElement(
            'div',
            { className: 'm-settings--cancel--actions' },
            _react2['default'].createElement(
                'div',
                { id: 'cancelSubscriptionButton' },
                _react2['default'].createElement(_button2['default'], {
                    buttonText: cancelButtonText,
                    buttonLink: '#',
                    buttonColor: 'grasshopper',
                    buttonClass: 'border-1-grasshopper',
                    buttonTextColor: 'white',
                    buttonHoverTextColor: 'white',
                    buttonHoverColor: 'castle-rock',
                    buttonHoverBorderColor: 'castle-rock',
                    type: 'submit',
                    onClick: this.onSubmit })
            ),
            _react2['default'].createElement(
                'div',
                { id: 'nevermindButton' },
                _react2['default'].createElement(_button2['default'], {
                    buttonText: 'Never mind',
                    buttonLink: _hfReactHelper2['default'].urlHelper('home/myAccount?current_tab=billing', siteCode),
                    buttonColor: 'white',
                    buttonClass: 'border-1-grasshopper',
                    buttonTextColor: 'grasshopper',
                    buttonHoverTextColor: 'white',
                    buttonHoverColor: 'grasshopper' })
            )
        );

        return _react2['default'].createElement(
            'form',
            { id: 'cancel_form', name: 'cancel_form', className: 'account-form', method: 'POST' },
            this.renderHiddenFields(),
            _react2['default'].createElement(
                'h1',
                null,
                'Are you sure you want to cancel?'
            ),
            _react2['default'].createElement(
                'h3',
                { className: 'm-cancel--subtitle' },
                'Canceling your paid account will downgrade your service to a Free account.'
            ),
            reminderList,
            _react2['default'].createElement('div', { className: 'm-settings--cancel--hr' }),
            _react2['default'].createElement(
                'h3',
                null,
                'If you do decide to cancel, we would really appreciate learning about your experience using HelloSign.'
            ),
            customerSupportInfo,
            cancellationAndCompetitorReasons,
            canWeFollowUpToggle,
            customerComments,
            cancelLegalWarning,
            this.props.hasBothApiAndUiPlans ? this.renderPlanSwitch() : void 0,
            _react2['default'].createElement('input', { type: 'hidden', name: 'redirect_url', value: this.props.redirectUrl ? this.props.redirectUrl : '' }),
            this.renderErrorText(),
            ctaButtons
        );
    }
});

module.exports = CancelSubscriptionForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/cancel-subscription/cancel-subscription-form.jsx
 ** module id = 1032
 ** module chunks = 0
 **/